import Show from "components/Show";
import { useApi } from "hooks";
import { useState } from "react";
import { useParams } from "react-router-dom";

type Props = {
   onSuccess?: () => void;
};

type PresignedUploadResponse = {
   upload_url: string;
   headers: Record<string, string>;
   path: string;
   file_name: string;
};

export default function UploadSmsStatsFile({ onSuccess }: Props) {
   const { recurrenceId } = useParams();
   const api = useApi({});
   const [uploading, setUploading] = useState(false);

   const onUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0];
      if (!file) {
         return;
      }

      setUploading(true);
      try {
         const contentType = file.type || "text/csv";
         const presignResponse = await api.post("/files/presigned-upload", {
            filename: file.name,
            content_type: contentType,
         });

         const { upload_url, headers, path, file_name }: PresignedUploadResponse = presignResponse.data.data;

         const uploadResponse = await fetch(upload_url, {
            method: "PUT",
            headers: {
               ...headers,
               "Content-Type": contentType,
            },
            body: file,
         });

         if (!uploadResponse.ok) {
            throw new Error(`Direct upload failed with status ${uploadResponse.status}`);
         }

         await api.post(`/campaign-recurrences/${recurrenceId}/process-statistics-file`, {
            path,
            file_name: file_name || file.name,
         });

         onSuccess && onSuccess();
      } catch (error) {
         console.error("Error uploading file:", error);
      } finally {
         setUploading(false);
         event.target.value = "";
      }
   };

   return (
      <div>
         <div className="border-2 relative border-dashed border-gray-300 rounded-lg p-6 text-center">
            <Show when={uploading}>
               <div className="py-3 text-center flex justify-center">
                  <div className="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-12 w-12"></div>
               </div>
            </Show>
            <Show when={!uploading}>
               <input type="file" className="absolute inset-0 w-full h-full opacity-0 cursor-pointer" accept=".csv" onChange={onUpload} />
               <div className="flex flex-col items-center justify-center h-full">
                  <svg className="w-12 h-12 mb-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                     <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                     ></path>
                  </svg>
                  <p className="text-gray-600">Glissez et déposez votre fichier de statistiques ici, ou cliquez pour sélectionner un fichier</p>
                  <p className="text-sm text-gray-500 mt-2">Formats acceptés: .csv</p>
               </div>
            </Show>
         </div>
      </div>
   );
}
